"use client";

import React from "react";
import ReactFlow, { MiniMap, Controls, Background, type NodeMouseHandler } from "reactflow";
import "reactflow/dist/style.css";
import { ContextMenu } from "./ContextMenu";
interface OrgChartViewProps {
  reactFlowWrapper: React.RefObject<HTMLDivElement>;
  nodes: any[];
  edges: any[];
  onNodesChangeAction: (changes: any) => void;
  onEdgesChangeAction: (changes: any) => void;
  onConnectAction: (connection: any) => void;
  onInitAction: (instance: any) => void;
  onNodeContextMenuAction: NodeMouseHandler;
  onPaneContextMenuAction: (event: React.MouseEvent) => void;
  onPaneClickAction: () => void;
  contextMenu: {
    x: number;
    y: number;
    type: "node" | "pane";
  } | null;
  nodeTypes: {
    [key: string]: any;
  };
  onDeleteNodeAction: () => void;
  onAddNodeAction: () => void;
}
export const OrgChartView: React.FC<OrgChartViewProps> = ({
  reactFlowWrapper,
  nodes,
  edges,
  onNodesChangeAction,
  onEdgesChangeAction,
  onConnectAction,
  onInitAction,
  onNodeContextMenuAction,
  onPaneContextMenuAction,
  onPaneClickAction,
  contextMenu,
  nodeTypes,
  onDeleteNodeAction,
  onAddNodeAction
}) => {
  return <div className="flex-1 rounded-lg border shadow-sm" ref={reactFlowWrapper} data-sentry-component="OrgChartView" data-sentry-source-file="OrgChartView.tsx">
      <ReactFlow nodes={nodes} edges={edges} onNodesChange={onNodesChangeAction} onEdgesChange={onEdgesChangeAction} onConnect={onConnectAction} onInit={onInitAction} onNodeContextMenu={onNodeContextMenuAction} onPaneContextMenu={onPaneContextMenuAction} onPaneClick={onPaneClickAction} nodeTypes={nodeTypes} fitView data-sentry-element="ReactFlow" data-sentry-source-file="OrgChartView.tsx">
        <Controls position="top-left" data-sentry-element="Controls" data-sentry-source-file="OrgChartView.tsx" />
        <MiniMap position="bottom-left" data-sentry-element="MiniMap" data-sentry-source-file="OrgChartView.tsx" />
        <Background data-sentry-element="Background" data-sentry-source-file="OrgChartView.tsx" />
      </ReactFlow>
      {contextMenu && <ContextMenu x={contextMenu.x} y={contextMenu.y} onDeleteNode={contextMenu.type === "node" ? onDeleteNodeAction : undefined} onAddNode={contextMenu.type === "pane" ? onAddNodeAction : undefined} />}
    </div>;
};
export default OrgChartView;